import { render, staticRenderFns } from "./inventoryDetails.vue?vue&type=template&id=1ed5af57&scoped=true"
import script from "./inventoryDetails.vue?vue&type=script&lang=js"
export * from "./inventoryDetails.vue?vue&type=script&lang=js"
import style0 from "./inventoryDetails.vue?vue&type=style&index=0&id=1ed5af57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5af57",
  null
  
)

export default component.exports